import { render, staticRenderFns } from "./heartStatistics.vue?vue&type=template&id=2382c201&scoped=true&"
import script from "./heartStatistics.vue?vue&type=script&lang=js&"
export * from "./heartStatistics.vue?vue&type=script&lang=js&"
import style0 from "./heartStatistics.vue?vue&type=style&index=0&id=2382c201&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2382c201",
  null
  
)

export default component.exports